import { render, staticRenderFns } from "./ContractorProjectsList.vue?vue&type=template&id=4b81a867&"
import script from "./ContractorProjectsList.vue?vue&type=script&lang=js&"
export * from "./ContractorProjectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports